import locales_en_US from './en-US/index';
import { AllMessagesType, LocaleType } from '../types/locale';
import { flattenMessages } from '../utils/flattenMessages';
import { supportedLanguages } from '../config/locale';

// Get browser's language
const browserLanguage: LocaleType = window.navigator.language as LocaleType;

//Default to english if browser's language is not supported
export const locale: LocaleType = supportedLanguages.includes(browserLanguage)
  ? browserLanguage
  : LocaleType.ENGLISH_US;

const allMessages: AllMessagesType = {
  [LocaleType.ENGLISH_US]: locales_en_US,
};

export const messages = flattenMessages(allMessages[locale]);
